import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { JobCard } from "@/components/site/JobCard";
import { RecruitmentDisclaimer, useFee, feeText } from "@/components/site/Notices";

export default function Careers() {
  const [data, setData] = useState({ jobs: [], total_vacancies: 0 });
  const fee = feeText(useFee());
  useEffect(() => {
    api.get("/jobs").then((r) => setData(r.data));
  }, []);
  return (
    <div className="container-x py-16">
      <div className="mb-10 grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <p className="text-xs font-bold uppercase tracking-widest text-amber-600">Careers / Apply for a job</p>
          <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Open positions</h1>
          <p className="mt-4 max-w-2xl text-slate-600">Choose a position, fill the online form, verify your email, upload your documents and submit. A {fee} application processing fee applies — see the <Link to="/policies/application-fee-refund" className="font-semibold underline">fee & refund policy</Link>.</p>
        </div>
        <div className="rounded-2xl bg-slate-900 p-6 text-white lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Total advertised vacancies</p>
          <p className="font-mono-num mt-1 text-4xl font-bold" data-testid="careers-total-vacancies">{data.total_vacancies.toLocaleString("en-IN")}</p>
        </div>
      </div>
      <p className="mb-4 rounded-xl border-l-4 border-amber-600 bg-amber-50 p-4 text-sm font-semibold text-amber-900" data-testid="careers-eligibility-notice">Eligibility: you can apply for any post only if you have passed secondary school (10th Pass).</p>
      <RecruitmentDisclaimer className="mb-8" />
      <div className="grid gap-6 md:grid-cols-2">{data.jobs.map((j, i) => <JobCard key={j.id} job={j} index={i} />)}</div>
    </div>
  );
}
